import React from 'react';
import { PopperArrowProps, RefHandler } from 'react-popper';
import cn from 'classnames';

import { formatDecimalOdd } from 'utils';
import Chart from './Chart';
import useOddHistory from './useOddHistory';

import './oddHistory.scss';

interface OwnProps {
    oddId: string;
    style: React.CSSProperties;
    fRef: RefHandler;
    arrowProps: PopperArrowProps;
    placement: string;
}

const OddHistory = ({
    oddId,
    style,
    fRef,
    arrowProps,
    placement,
}: OwnProps) => {
    const { dynamics, oddName, marketName, oddFormat } = useOddHistory({
        oddId,
    });

    const firstCoef = dynamics[0];
    const secondCoef = dynamics[dynamics.length - 1];

    if (!firstCoef || !secondCoef) return null;

    const { component: first } = formatDecimalOdd(firstCoef, oddFormat);
    const { component: last } = formatDecimalOdd(secondCoef, oddFormat);

    return (
        <div style={style} ref={fRef} styleName="container">
            <div styleName="header">
                <div styleName="title">{marketName}</div>
                <div styleName="text">{oddName}</div>
            </div>
            <div styleName="main">
                <div styleName="min-max">{first}</div>
                <div styleName="graph">
                    <div styleName="graph-block">
                        <Chart data={dynamics} />
                    </div>
                </div>
                <div styleName="min-max">{last}</div>
            </div>
            <div
                styleName={cn('arrow', {
                    'is-bottom': placement === 'bottom',
                })}
                style={arrowProps.style}
                ref={arrowProps.ref}
            />
        </div>
    );
};

export default React.memo(OddHistory);
